import { render } from "./Ilustracao.vue?vue&type=template&id=12719744&scoped=true&ts=true"
import script from "./Ilustracao.vue?vue&type=script&lang=ts"
export * from "./Ilustracao.vue?vue&type=script&lang=ts"

import "./Ilustracao.vue?vue&type=style&index=0&id=12719744&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12719744"]])

export default __exports__